module.exports = __webpack_public_path__ + "static/media/sort-alpha-down.5f4ce358.svg";